module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "chap2",
      "src": "images/chap2.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("EMERGING ADULT FAITH")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("NOT AN LP, BUT A DIGITAL DOWNLOAD")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_vm._v("[Being a spiritual bricoleur] involves piecing together ideas about spirituality from many sources, especially through conversation with one’s friends. We have seen that spiritual choices are not limited to the kinds of denominational switching that some scholars are content to emphasize. . . . It also takes the form of searching for answers to the perennial existential questions in venues that go beyond religious traditions.")]), _c('div', {
    staticClass: "exer_source"
  }, [_c('b', [_vm._v("ROBERT WUTHNOW")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("W")]), _vm._v("here is the interaction of science and religion headed? Is there going to be a fight to the death? A pleasant détente? Or something collaborative?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Apparently this question was on the mind of mathematician and philosopher Alfred North Whitehead when he was nearing retirement in the mid-1920s. One of the greatest intellectuals of the late nineteenth and early twentieth centuries, Whitehead had coauthored the epic tome "), _c('i', [_vm._v("Principia Mathematica")]), _vm._v(" with the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("celebrated philosopher Bertrand Russell on the philosophy of mathematics while at Cambridge. He had also labored to develop the mathematics that undergird relativity theory. He was continually dedicated both to the practice of and reflection on science. Robert Lowell, then president of Harvard University, had an idea. Knowing this intellectual star was finishing his time at the Imperial College of Science and Technology in London and that English law was about to force his retirement, Lowell invited the sixty-three-year-old Whitehead to Harvard in 1924 with a purpose: to set aside his purely scientific pursuits for sustained reflection on a new philosophy of nature. When Whitehead’s wife asked him about the offer, Whitehead replied, “I would rather do that than anything in the world.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In one of Whitehead’s first books during those early years at Harvard, "), _c('i', [_vm._v("Science and the Modern World ")]), _vm._v("(1925), he reflected on the way science is embedded in Western culture:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("When we consider what religion is for mankind and what science is, it is no exaggeration to say that the future course of history depends upon the decision of this generation as to the relations between them. We have here the two strongest forces (apart from the mere impulse of various senses) which influence men, and they seem to be set one against the other—the force of our religious intuitions, and the force of our impulse to accurate observation and logical deduction."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We are far from his generation, but “Whitehead’s Challenge” still has merit.")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-004"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_droite"
  }, [_vm._v("“I believe religion is holding us back as a species.”")]), _c('div', {
    staticClass: "dev_source"
  }, [_c('b', [_c('i', [_vm._v("DEVAN, CHICO STATE UNDERGRADUATE")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In a somewhat different location on the intellectual food chain, the quirky independent film "), _c('i', [_vm._v("Nacho Libre")]), _vm._v(" provides commentary. In the movie, Nacho (or Ignacio) cooks for a Mexican monastery but moonlights as a tag-team wrestler, a “luchador libre,” with his partner, Stephen. Nacho is a man of faith, but Stephen denies any belief in God and declares "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("that he is “a man of science.” This is a point of contention and it makes Nacho feel fearful, especially just before they fight the team of “Satan’s Cavemen.” In the dressing room before the fight, while Stephen is looking another direction, Nacho surprises Stephen by ambushing him from behind with a guerilla baptism, dunking his head in a plastic basin. My point (yes, I do have one) is that in church we often baptize scientists and the insights that seem convenient to our theological purposes while they’re not looking. We’re afraid to enter the nitty-gritty of really understanding what scientists do and think. I’m convinced that this is not the best course for the future.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Sketching Emerging Adulthood")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Whitehead’s questions—and Nacho’s answers—have rattled around in my brain for more than three decades. I already mentioned the Haussauer Problematic, the challenge laid down by my comparative literature professor. When I started pursuing church ministry, that problematic continued to trouble me. In my first year at Princeton Seminary, Diogenes Allen started his lectures on philosophy by addressing the challenges brought to Christian belief by Hume, Kant, and scientific thinking. Ultimately, he told us, these two Enlightenment titans and their concerns wouldn’t prove insurmountable, but the point still stuck: scientific rationality posed numerous challenges to the Christian faith. I then traveled to Germany and studied how Whitehead’s philosophy interacted with Karl Barth’s theology, which culminated in a PhD from the Graduate Theological Union and its Center for Theology and the Natural Sciences.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("During my church ministry years I tried to bring all of this study to the congregations I served, which were filled with college students (First Presbyterian Church, Berkeley), postcollege twenty-something "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("urban professionals (Fifth Avenue Presbyterian, New York City), and more college students (Bidwell Presbyterian, Chico). Now I teach at Chico State University. My church and academic years have been filled with emerging adults, faith, and science.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What have I learned? Considering the Haussauer Problematic, Whitehead’s Challenge, and Nacho’s Answer, how are emerging adults changing the conversation of faith and science? Who, in fact, are emerging adults? What are their attitudes about the changing world they are both inhabiting and creating? And where is the integration of science and faith headed in the future? To answer these questions, we’ll look at the work of Princeton sociologist Robert Wuthnow, along with that of Jonathan Hill, Elaine Howard Ecklund, and Christian Smith."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" We’ll also consider insights gathered through my team’s eighteen-month SEYA research on the attitudes of eighteen- to thirty-year-olds toward faith and science."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Let me say a few brief words about how this study was conducted. A SEYA team first met with emerging adult participants to teach about the integration of science and religion and hold informal discussions. We presented groups in Northern California and in New York City—a total of 638 participants—with a questionnaire based on surveys from Smith’s "), _c('i', [_vm._v("Souls in Transition")]), _vm._v(" and Kinnaman’s "), _c('i', [_vm._v("You Lost Me")]), _vm._v(" and asked these groups to study and to discuss key resources."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" This usually happened during a four- to six-week period, and we surveyed them before and after to discern whether experiencing this religion and science curriculum made a difference in their attitudes about the possibility of integrating the two.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I also convened a group of twelve thought leaders in emerging adult culture—biblical scholars, theologians, pastors, and a seminary president and dean—to discuss their insights. Finally, I conducted (and am continuing to conduct) in-depth qualitative interviews with thirty college students and postcollege emerging adults."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" (These will appear "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("throughout the chapters.) These interviews offer contour and nuance to cold statistics because attitudes on religion and science don’t fit neatly into four or five boxes, only one of which you can check. Interestingly, my analysis has mirrored the conclusions of wider demographic research from leading scholars.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Feeling “In-Between”")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The term "), _c('i', [_vm._v("emerging adulthood")]), _vm._v(" may not be entirely familiar. Since I’m analyzing eighteen- to thirty-year-olds primarily from the angle of psychological developmental, it’s appropriate to note that a psychologist, Jeffrey Arnett, first defined this category in 2000 as a stage of life in which a person no longer feels like an adolescent but is not yet fully an adult."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Though I have some questions (for example, how well it applies universally across the United States), I find the paradigm illuminating. It recognizes the current cultural shift in which individuals are reaching the five milestones of adulthood—leaving home, finishing school, becoming financially independent, getting married, and having children—later than they did in the past."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" A 2009 analysis found that in 1960, two-thirds of young adults had achieved all five of these markers by age thirty, but by 2000, less than fifty percent of women and one-third of men had done so."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" We could simplify this by focusing (with Wuthnow) on two markers: Americans are marrying and having children later."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These factual markers have psychological importance. Many of us used to know where to go when we turned eighteen—we graduated from high school, left home and headed to college, landed a job, got married, bought a house, and had kids. For many this path felt stultifying, but it was at least clear. Today, an increasing number of eighteen- to thirty-year-olds feel “in between.” Arnett portrays emerging adulthood using five interrelated characteristics: (1) Emerging adults are actively looking for personal meaning and identity. (2) Their lives "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("are marked by instability due to regular relocations, job changes, and revision of life plans. (3) They tend to be self-focused, liberated from parental oversight and significant responsibility for others. (4) They feel (here’s the summary phrase) “in between”—beyond adolescence but not yet full adult. (5) Finally, they live in an “age of possibilities,” optimistic about the future and keeping their options open."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Naturally this is a generalization; those at lower socioeconomic levels often develop job skills more quickly and thus move out of adolescent life and into adult responsibilities earlier than their peers of greater affluence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" With that caveat in mind, it’s still worth remembering that eighteen- to thirty-year-olds are often markedly uncommitted to church life and marriage. Since the marrying age is around twenty-eight for men and twenty-six for women,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" most emerging adults’ relationship to faith is not defined by family. Their reality presents a jarring contrast to the organization of most congregational ministries. Simply put, most churches are focused on the family (as it were) and have no place for emerging adults in their twenties. As Arnett puts it, “Having left the dependency of childhood and adolescence, and having not yet entered the enduring responsibilities that are normative to adulthood, emerging adults often explore a variety of possible life directions in love, work, and worldviews.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As one who became a Christian at the cusp of emerging adulthood and led college and postcollege ministries for two decades, I read these characteristics with empathy, excitement, and concern. I’m expectant to see how emerging adults change the way we receive and live out the gospel. The future isn’t what it used to be (to paraphrase the late prophet and Yankees catcher Yogi Berra). Members of this generation are making great contributions through their creativity, energy, and openness to new ideas. They are, after all, continuing to define what it means to live in a “digital age” (a topic to which we will return). Over my years with this demographic, I have come to treasure their spontaneity and believe that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("they will make a difference despite enormous challenges such as rising debt, overpopulation, and global climate change.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I also wonder how we who are older have prepared this generation. Frankly, I think we have often failed, as evidenced by the deep anxiety associated with their “in-betweenness.” Here I can speak from experience—I’ve been the pastor of hundreds of emerging adults. I’ve held numerous conversations in my church office or at Peet’s Coffee, talked with them while building houses in Mexico, chatted casually at Christmas parties or after small group meetings. Consequently, this statement from emerging-adult ministry specialists David Setran and Chris Kiesling brings me pain:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Because many of the stable and scripted road maps of the adult life course have vanished, there is little clear direction on how to proceed through the twenties. In a period of instability, continual change, and new freedom, the weight of personal responsibility can be overwhelming."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As a result of this instability, some even talk of a “quarterlife crisis.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-035",
      "id": "ap_ntf-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" In other words, the challenges of twenty-something life may be more extreme than those of midlife.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Just in case you haven’t become fully despondent, psychologist and counselor Meg Jay argues in "), _c('i', [_vm._v("The Defining Decade")]), _vm._v(" that the twenties define the rest of one’s life, particularly in the areas of work, love, and how our brains relate to our bodies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-036",
      "id": "ap_ntf-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Note that Jay doesn’t espouse Christian faith as a resource for the problems she presents—suffice it to say that her chapter on marriage begins with a call for more teaching on relationships for twenty-somethings and continues through a description of the “cohabitation effect” (the fact that cohabiting before marriage is correlated with higher rates of divorce). In accordance, I find that emerging adults are adrift in their romantic (and often sexual) relationships as a result of their generally being undirected.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("I mentioned earlier a meeting of twelve of the best thought leaders in emerging-adult culture I could find. As I sat with these Christian leaders in a Fuller Seminary conference room with southern California sunlight filtering through the windows (and through the smog), they described this demographic with some important words and phrases. One observation was that the lives emerging adults live are “marked by instability in relationships, purpose, and faith.” Similarly, we found that the word "), _c('i', [_vm._v("anxiety")]), _vm._v(" resonated strongly with our combined years of young-adult pastoral ministry. As Setran and Kiesling conclude, “While many of these emerging adult changes can be exhilarating, they also tend to produce a great deal of anxiety.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-037",
      "id": "ap_ntf-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is this openness and related anxious stress that characterize the lives of eighteen- to thirty-year-olds and set the context for their culture. Moreover, these specialists commented, emerging adults “are caught in the pastiche of postmodernism. At times they can display delayed self-awareness.” They added somewhat harshly if also memorably that eighteen- to thirty-year-olds can be “choice-phobic.” Choice phobia obviously relates to relationships but can also characterize commitment to following Christ and to Christian community. This generation has been nurtured in tolerance as a response to pluralism. Nonetheless—lest I sound like this session was one huge complaint session—these leaders all affirmed their love for emerging adults and their excitement about the possibilities they bring to the church, including their incredible technological savvy and ability to take in a wide range of ideas.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So is this new reality good or bad? Smith, who tends toward the negative in his assessment, still summarizes well both the positive and negative sides of the emerging-adult experience:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The features marking this stage are intense identity exploration, instability, a focus on self, feeling in limbo or in transition or in between, and a sense of possibilities, opportunities, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("unparalleled hope. These, of course, are also often accompanied . . . by large doses of transience, confusion, anxiety, self-obsession, melodrama, conflict, disappointment, and sometimes emotional devastation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-038",
      "id": "ap_ntf-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It’s worth noting that Smith’s follow-up to his first study highlights the shadow side of emerging adulthood, as the subtitle makes clear: "), _c('i', [_vm._v("Lost in Transition: The Dark Side of Emerging Adulthood")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-039",
      "id": "ap_ntf-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Not all is right in Denmark—or at least with emerging adulthood.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is, of course, entirely possible and utterly faithful for emerging adults to transform their experience of being “in between,” with its consequent worry, into a radical openness to what God can do. I’ve seen plenty of eighteen- to thirty-year-olds do just that. In that light, Eugene Peterson’s paraphrase of Philippians 4:6-7 is brilliant:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Don’t fret or worry. Instead of worrying, pray. Let petitions and praises shape your worries into prayers, letting God know your concerns. Before you know it, a sense of God’s wholeness, everything coming together for good, will come and settle you down. It’s wonderful what happens when Christ displaces worry at the center of your life. ("), _c('i', [_vm._v("The Message")]), _vm._v(")")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Notice the displacement of worry with Christ. That’s a powerful image. I’m hoping this generation will take the raw material of emerging adulthood, center it on Christ, and let God do a new thing ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Isaiah+43%3A19&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Isaiah 43:19")]), _vm._v(") in all kinds of areas, including science and faith.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("LP  or Digital Download? Three Reflections")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This sketch of emerging adulthood and faith leads me to an interim question: What would it look like for Christian ministries to engage science and faith in ways that resonate with eighteen- to thirty-year-olds? Here are three possibilities.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("First of all, we’d take on some new topics. Technology—for example, the psychological and behavioral effects of screen time, the possibility of artificial intelligence, the promise of transhumanism—has become central to science and religion in the past decade or so; it’s not just pure science anymore (Big Bang cosmology and evolution, step aside). In addition, we’d look at new concerns about sexuality and gender (not something you’d find in a standard religion and science textbook). And finally, we’d examine the materialistic philosophy often enshrined in “the findings of neuroscience” that there is no immaterial soul. We’ll discuss these in more detail later on.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Second, we’d understand faith in a new way. If any one thing characterizes contemporary emerging adult life, it’s pluralism—this generation has been formed in an age of dazzling diversity of all kinds, including that of worldview, religion, sexual identity, race, and ethnicity. Life is open, holding more possibilities than it ever has for past generations. In a worldview or religious context, this means that emerging adults often live, in varying degrees, as “spiritual bricoleurs.” And if “bricoleur” doesn’t work for you, try “tinkerer”—it means the same thing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-040",
      "id": "ap_ntf-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" This open spiritually means emerging adults often are uncommitted to religious institutions in general and churches in particular. All of this leads Smith to conclude that “emerging adults are, on most sociological measures, the least religious adults in the United States today.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-041",
      "id": "ap_ntf-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" This gives many congregations pause and, frankly, prevents them from seeing ministry with eighteen- to thirty-year-olds as a worthwhile investment (not to mention that these young people don’t often contribute much to the collection plate—partly because they don’t carry cash or checks).")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-005"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_gauche"
  }, [_vm._v("“When it comes to religion and spirituality, I think I would describe myself as more religious than spiritual. I attend mass occasionally and spend time praying when I’m troubled or thankful.”")]), _c('div', {
    staticClass: "dev_source"
  }, [_c('b', [_c('i', [_vm._v("MARIA, AGE 18")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("Third, we’d see Christian faith as a Spotify mix instead of a vinyl LP, with listeners choosing from a variety of artists based on a certain mood or a feel. At this point, I sometimes tell my college students that it’s time to take a trip down memory lane. In the old days I used to drive to Tower Records and thumb through aisles of twelve-inch-square cardboard album covers, looking for the right “long-play” recording. Afterward, an LP or two tucked under my arm, I’d journey home, take musical refuge in my room, place the vinyl LP on a turntable, and listen to side A in the sequence the band had set—not an order I constructed. Then I’d go to side B. One album. One sequence. Today, music isn’t bound by the sequence set by the artists. Neither is our belief. We have the ability to mix music based on the algorithmic features of Pandora or our iPhone. The listener, not the musician, determines the sequence of the music today. The parallels with faith are reasonably clear.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This means that emerging adults are leading us out of the two-dimensional “science and religion” dichotomy to something much more multidimensional. Here’s what this looks like in my ministries: a college student might attend worship at Bidwell Presbyterian Church, take part in a weekly InterVarsity meeting, participate in a small group put together by Cru, go on a yearly mission trip to Mexico with another church, then do a little yoga on the side without any sense of concern. He didn’t take the Bidwell Presbyterian LP off the shelf and play through our selected sequence of worship service–small group–large group–mission trip. Emerging adults are experimenting with various spiritual inputs both inside and outside congregations and campus ministry groups.")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-006"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_gauche"
  }, [_vm._v("“You can be a Christian, but it never hurts to meditate.”")]), _c('div', {
    staticClass: "dev_source"
  }, [_c('b', [_c('i', [_vm._v("LUPE, AGE 19")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Put a slightly different way, faith and science are becoming increasingly pluralistic. Talking about “religion and science” may seem like a dialogue between two things, but eighteen- to thirty-year-olds see it differently. They have grown up in environments saturated with options and possibilities. And though pluralism is certainly not new—the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("apostle Paul referred to the many “gods” in Corinth, and the United States is known as a “melting pot,” for example—the experience of it has increased through the explosion of knowledge on the Internet. Consider that the number of websites has topped one billion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-042",
      "id": "ap_ntf-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Admittedly, it’s also a question whether science is one thing or whether there are multiple sciences, and this further complicates the interaction. In many languages—French, for example—the term is usually plural. So to be a science major in school is literally “to study the sciences.” Similarly, British English speaks of “maths” in the plural. Even if we make it a singular word, there are many kinds of math that correspond to different areas of study."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-043",
      "id": "ap_ntf-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Similarly, if we think of “science” in the singular, it is at minimum a set of disciplines. Biology and chemistry are not the same areas of study with precisely the same methods.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So can the church make the engagement of mere Christianity with mainstream science a Spotify mix? I’m not suggesting that taking a fresh approach to science and faith will halt the exodus of the nones and emerging adults will suddenly flood back into churches. But I think the climate has changed. And that is a fact we can’t deny.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Speaking of the “nones,” one popular portrayal is not very pluralistic at all. A loud cultural narrative is increasing loss of belief as knowledge and science devour faith. Science wins. Faith loses. Let’s look at a case study about the “New Atheists,” who are largely responsible for this narrative.")])])]), _c('section', {
    staticClass: "schap",
    attrs: {
      "epub:type": "subchapter",
      "id": "schap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_c('h1', {
    staticClass: "schap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("CASE STUDY")])]), _c('h1', {
    staticClass: "schap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("ADDRESSING"), _c('br'), _vm._v("THE NEW ATHEISM")])]), _c('h1', {
    staticClass: "schap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "carr",
      "src": "images/traingle.jpg"
    }
  })])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_vm._v("Question: What were the greatest influences in coming to your decisions about religion and science? Answer: “Watching documentaries about Richard Dawkins and Neil Degrasse Tyson. And friends— a discussion of what they’ve seen on the Internet.”")]), _c('div', {
    staticClass: "exer_source"
  }, [_c('b', [_vm._v("TREVOR, FIRST-YEAR UNDERGRAD")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("S")]), _vm._v("cientifically informed atheism affects emerging adults today. That makes it worthy of a brief consideration and response.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The New Atheism and its “four horsemen”—by which I mean Richard Dawkins, Christopher Hitchens, Daniel Dennett, and Sam Harris—arose in the 2000s after the horrors of religiously informed violence. This leads some people to conclude that the wave of New Atheism has already crested—it was brought on by the religiously motivated violence of 9/11 and is now receding into the past.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’m not entirely sure that’s true. With ISIS and other militant groups making news regularly, there’s still plenty of violence to fuel slogans such as “If you really want violence, try religion.” I also still hear the voices of the New Atheists echoed by my students and other emerging "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("adults. Besides that, materialism (a worldview focused exclusively on the material world) has been around for millennia. So whether this atheism is “new” is in question—it’s a recurrent theme of humanity that also affects today’s emerging adults.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I should mention that I don’t often encounter the sneer and hard-edged approach to Christian faith that Dawkins emits and embodies. The key value I find in eighteen- to thirty-year-olds is tolerance. The attitude of atheist students today is kinder and gentler than that of my Berkeley classmates in the eighties, who seemed intent on disproving my faith. In addition, it’s important to note that these New Atheists don’t speak for all scientists. Consider what one nonreligious scientist had to say about Dawkins: “He’s much too strong about the way he denies religion. . . . As a scientist, you’ve got to be very open, and I’m open to people’s belief in religion. . . . I don’t think we’re in a position to deny anything unless it’s something which is within the scope of science to deny.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-044",
      "id": "ap_ntf-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So their tone is off, but the New Atheists still have influence, and their ideas are worth our attention. Consider the criticism laid before believers by the late brilliant and voluble Christopher Hitchens in his “Hitchens’s Razor”: “That which can be asserted without evidence can be dismissed without evidence.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-045",
      "id": "ap_ntf-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" In other words, faith, according to Hitchens and his ilk, is not rational. Here’s Dawkins again:")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-007"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_gauche"
  }, [_vm._v("“I think most people are neutral— ‘It’s cool if you believe it.’ If they want to believe, more power to ’em.”")]), _c('div', {
    staticClass: "dev_source"
  }, [_c('b', [_c('i', [_vm._v("AMANDA, AGE 19,"), _c('br'), _vm._v("ATHEIST")])])])])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("What, after all, is faith? It is a state of mind that leads people to believe something—it doesn’t matter what—in the total absence of supporting evidence. If there were good supporting evidence, faith would be superfluous, for the evidence would compel us to believe it anyway."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-046",
      "id": "ap_ntf-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("Oxford theologian Alister McGrath responds, “Dawkins’s definition of faith . . . bears no recognizable resemblance to what Christians believe.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-047",
      "id": "ap_ntf-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Accordingly, when presenting the nature of faith in "), _c('i', [_vm._v("Mere Christianity,")]), _vm._v(" Lewis wrote, “Faith, in the sense in which I am here using the word, is the art of holding on to things your reason has once accepted, in spite of your changing moods.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-048",
      "id": "ap_ntf-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" That sounds jarringly different from the simplifications and canards the atheists are selling—and much more robust and interesting. Overall, the New Atheists have made a name for themselves—it is capitalized after all!—by setting up a number of straw men and then congratulating themselves on their superior intellect when they find them easy to obliterate.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And yet looming around the conviction that the church needs to integrate mainstream science are voices such as Dawkins’s saying that evolution makes this impossible:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("I think the evangelical Christians have really sort of got it right in a way, in seeing evolution as the enemy. Whereas the more, what shall we say, sophisticated theologians are quite happy to live with evolution, I think they are deluded. I think the evangelicals have got it right, in that there is a deep incompatibility between evolution and Christianity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-049",
      "id": "ap_ntf-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I find it deeply troubling that we choose to get our theology—or even our understanding of evolution—from Richard Dawkins.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It’s important to reiterate that not all “nones” are equal atheists. “Nones” are about 30 to 34 percent of the emerging adult population, but atheists represent only about 6 percent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-050",
      "id": "ap_ntf-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Still, the New Atheists speak for many who are disaffected from the church. That’s why Dawkins is so popular among “half-convinced” atheists. It’s not his arguments. It’s that he says things they agree with and that sound convincing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-051",
      "id": "ap_ntf-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-008"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_gauche"
  }, [_vm._v("On Richard Dawkins: “He has brought up many points that I question or have questioned myself, and for this I would say I look up to Dawkins.”")]), _c('div', {
    staticClass: "dev_source"
  }, [_c('b', [_c('i', [_vm._v("DANIELLE, AGE 19")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("Here’s how I counter atheism. When Dawkins asserts that some religious people hold beliefs that are childish and irrational, this does not prove that all believers do, nor does it prove that Christian faith is an unreasonable or unreasoned delusion. I might just as readily conclude that all atheists are caustic and arrogant because Dawkins is. But that would be an unjust judgment and untrue.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Of course, it’s often not rationality per se—especially when it comes to science—that turns people away from faith. It can be an intimate group of friends (the “tribe”), the obnoxious acquaintance who’s a Jesus freak, or some personal pain they’ve experienced that they can’t reconcile with the existence of a good God. All of that gets mixed in with what’s deemed “rational.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We could turn the tables and point to the historical connection between Christian doctrine and the rise of modern science. Is there any good reason to believe that this universe is coherent and consistent and rational if there isn’t a God? Historically, the growth of scientific discovery has been based on the underlying assumption of a rational universe. As the Nobel Laureate and UC Berkeley physicist Charles Townes notes, “For successful science of the type we know, we must have faith that the universe is governed by reliable laws and, further, that these laws can be discovered by human inquiry.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-052",
      "id": "ap_ntf-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Whitehead is good here too: “There can be no living science unless there is a widespread conviction in the existence of an Order of Things, and, in particular, of an Order of Nature.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-053",
      "id": "ap_ntf-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" To have a cosmos and not a chaos requires an Orderer. Without that, the atheists’ assumption of a rational cosmos is based on faith, not a reasonable deduction from "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("their metaphysics. Science and rationality have an inherent link with God the Creator.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("God’s ordering our cosmos brings with it the existence of goodness—and the related realities of meaning, purpose, and beauty—and these together present an almost insoluble problem for the atheist.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thankfully, I didn’t actually have to formulate the problem of good on my own. Prominent atheists have already taken on that task for me. Consider Dawkins’s words:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("In a universe of blind physical forces and genetic replication, some people are going to get hurt, other people are going to get lucky, and you won’t find any rhyme or reason in it, nor any justice. The universe that we observe has precisely the properties we should expect if there is, at bottom, no design, no purpose, no evil and no good, nothing but blind, pitiless indifference."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-054",
      "id": "ap_ntf-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-009"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_droite"
  }, [_vm._v("“Science as a worldview is quite popular. ‘This is what you can really trust. This you can prove.’”")]), _c('div', {
    staticClass: "dev_source"
  }, [_c('b', [_c('i', [_vm._v("BRIAN, AGE 23")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That’s a reasonably bleak portrayal of the universe and, since we’re part of that universe, of our lives as well. It does, however, correspond perfectly with a basic tenet of Philosophy 101: nothing comes from nothing. Start with a purely physical system without any Creator, and all you have is brute fact. If the universe is simply a physical system, then why should something nonphysical like goodness, meaning, purpose, or beauty arise? It cannot.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Margaret Geller, astrophysicist at the Harvard-Smithsonian Center for Astrophysics, concludes that it’s pointless to mention purpose in the universe: “Why should it have a point? What point? It’s just a physical system, what point is there?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-055",
      "id": "ap_ntf-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" And given certain implied metaphysics—that it’s nothing but a physical system—she’s right. There will no be point and no good without something from outside infusing the system with these qualities. The words "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("I’m typing right now have no meaning, no potential goodness or beauty, without the intention of my brain (such as it is), as well as the context that words lend to sentences and thoughts. In the Western cultural tradition, of course, meaning and goodness come not from something but from Someone—a Creator or, better, an Informer who imbues the physical system with nonphysical qualities of information in the act of creation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But, of course, Western culture is gradually moving away from belief in creation by a good, meaningful, purposeful, and beautiful Creator. Weinberg, the atheistic scientist, states this problem pointedly: “The more the universe seems comprehensible,” he asserts, “the more it also seems pointless.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-056",
      "id": "ap_ntf-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Put another way, as we increase in scientific knowledge, we decrease in our ability to comprehend meaning. Pointless indeed. This is the sterility of the narrative of purely materialist science.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Why is this not a greater debate with the so-called New Atheists? More often we hear the challenge, “How can you believe in a good, almighty God when there’s so much suffering in the world?” Put simply, atheism confronts believers with the problem of evil.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yes, there indeed exists an intractable problem of evil. The Bible laid down the quandary millennia ago:")]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("Mortals, born of woman,")]), _c('p', {
    staticClass: "verslg"
  }, [_c('span', {
    staticClass: "tabulation"
  }, [_vm._v("are of few days and full of trouble.")])]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("They spring up like flowers and wither away;")]), _c('p', {
    staticClass: "verslg"
  }, [_c('span', {
    staticClass: "tabulation"
  }, [_vm._v("like fleeting shadows, they do not endure. ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Job+14%3A1-2&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Job 14:1-2")]), _vm._v(")")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Pain hurts, and it’s hard to square with God’s existence. For this reason the problem of evil remains the greatest argument against belief in God, and it’s been addressed by the great medieval philosopher Thomas Aquinas as well as contemporary thinkers such as C. S. Lewis and Alvin Plantinga.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("Still, I offer a counter-question: If you show me a world without a Creator, then you also need to provide grounds for the existence of goodness in this world. How do you intend to answer the problem of good in a world without God?")])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-010"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_droite"
  }, [_vm._v("Question: What’s the best relationship between religion and science? Answer: “If it works for people, let it be.”")]), _c('p', {
    staticClass: "txt_courant_centre retrait_droite"
  }, [_c('b', [_c('i', [_vm._v("DANIELLE, AGE 19, ATHEIST")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Often the response is a bald assertion that human beings supply the qualities lacking in a world devoid of God. Back to Weinberg, who comments a bit bleakly on how to find meaning through striving to grasp reality: “The effort to understand the universe is one of the very few things that lifts human life a little above the level of farce, and gives it some grace of tragedy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-057",
      "id": "ap_ntf-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" When asked later in an interview about this comment, he added, “There is a point that we can give the universe by the way we live, by loving each other, by discovering things about nature, by creating works of art. . . . Faced with this unloving, impersonal universe, we make a little island of warmth and love, and science and art, for ourselves—that’s not an entirely despicable a role for us to play.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-058",
      "id": "ap_ntf-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I find myself sympathetic to his conviction, but I also hear the thud of an unfounded leap of blind faith. And so, from the mouths of atheists, it sounds like the problem of good is insoluble. And I believe it is—without an act of faith. The question is this: Will this faith be reasonable or not?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In conclusion, let’s listen to atheists as voices for emerging-adult concerns, but let’s not be overwhelmed by their assertions of rationality. Neither unbelief nor belief is purely intellectual, and sound reasons exist for doubting atheism. Rational argument ultimately doesn’t change a person, but sometimes it leads them forward. I know it did for me as a functional atheist meandering down UC Berkeley’s Sproul Plaza.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 69
// module chunks = 0